import { Grid, SxProps } from '@mui/material';
import { CenterContainer } from '@/components/blocks/CenterContainer';
import { combineSX } from '@/utils/combineSX';

interface DpSEOSectionProps {
	children: React.ReactNode;
	sx?: SxProps;
	sxgrid?: SxProps;
}

export const DpSEOFrameDeporteEntrenamiento: React.FC<DpSEOSectionProps> = ({
	children,
	sx,
	sxgrid,
	...props
}) => (
	<CenterContainer
		sx={combineSX([
			{ background: '#FBFBFC', mt: '40px', mb: '40px' },
			...(Array.isArray(sx) ? sx : [sx]),
		])}
	>
		<Grid container sx={combineSX([...(Array.isArray(sxgrid) ? sxgrid : [sxgrid])])} {...props}>
			{children}
		</Grid>
	</CenterContainer>
);
